module.exports = __webpack_public_path__ + "img/icon_clock.04c7f77.png";